import { Box, Option, Select, Typography } from '@mui/joy'
import { KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import IconButton from '@mui/joy/IconButton'
import PropTypes from 'prop-types'
import { PAGINATION_PER_PAGE_OPTIONS } from 'utils/config'

const TablePaginationDesktop = ({ pagination }) => {
  return (
    <>
      <Box
        sx={{
          pt: 2,
          pb: { xs: 2, sm: 0 },
          gap: { xs: 1, sm: 3 },
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: '1fr auto 1fr',
          },
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            gap: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'unset' },
          }}
        >
          <Typography level="body-sm">Wiersze na stronę: </Typography>
          <Select
            variant="plain"
            size="sm"
            defaultValue={pagination.values.perPage}
            onChange={(_, newValue) => pagination.setPerPage(newValue)}
            indicator={<KeyboardArrowDown />}
            sx={{ minWidth: 65 }}
          >
            {PAGINATION_PER_PAGE_OPTIONS.map((option) => (
              <Option key={option} value={option}>
                {option}
              </Option>
            ))}
          </Select>
        </Box>

        <Box
          sx={{
            gap: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'unset' },
          }}
        >
          <Typography level="body-sm">
            {pagination.values.currentPage * pagination.values.perPage - pagination.values.perPage + 1}&nbsp;–&nbsp;
            {pagination.values.total >= pagination.values.currentPage * pagination.values.perPage
              ? pagination.values.currentPage * pagination.values.perPage
              : pagination.values.total}
            &nbsp;z&nbsp;
            {pagination.values.total}
          </Typography>

          <Box>
            <IconButton
              size="sm"
              disabled={!pagination.values.prevPage}
              onClick={() => pagination.setPage(pagination.values.prevPage)}
            >
              <KeyboardArrowLeft />
            </IconButton>
            <IconButton
              size="sm"
              disabled={!pagination.values.nextPage}
              onClick={() => pagination.setPage(pagination.values.nextPage)}
            >
              <KeyboardArrowRight />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </>
  )
}

TablePaginationDesktop.propTypes = {
  pagination: PropTypes.shape({
    values: PropTypes.shape({
      total: PropTypes.number.isRequired,
      currentPage: PropTypes.number.isRequired,
      perPage: PropTypes.number.isRequired,
      nextPage: PropTypes.number,
      prevPage: PropTypes.number,
    }),
    setPerPage: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    setPagination: PropTypes.func.isRequired,
  }),
}

export default TablePaginationDesktop
